// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2V8wV","inputWrap":"Table_inputWrap__k4Z5k","col":"Table_col__3w8gk","bmiTooltip":"Table_bmiTooltip__2yAd0"};